import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getRumbleTalkSettings = ({
  rumbletalkChatId
}: Partial<ChatsChannelBase>) => {
  if (!rumbletalkChatId) return null;

  const url = `https://p.rumbletalk.com/?h=${rumbletalkChatId}`;

  return {
    provider: ChatsChannelType.rumbletalk,
    link: { url },
    title: 'RumbleTalk',
    icon: getChatIcon(ChatsChannelType.rumbletalk),
    color: 'rgb(116, 172, 0)'
  } as ChatsChannelSetting;
};
